import * as ReferrerHelper from './common/utils/ReferrerHelper';
import { getWidget } from './common/widget';

(function () {
    'use strict';

    function main() {
        var controller = {
            init: function () {
                var widget = wo$('[data-widget-type="broadband-speed"]');
                if (!widget.length) return;

                widget
                    .find('#view-full-results')
                    .off('click')
                    .on('click', function () {
                        WhistleOut.trackEvent('BroadbandSpeed', 'ViewFullResults');
                    });
                widget
                    .find('[data-transaction]')
                    .off('click')
                    .each(function () {
                        // TODO: href logic to common

                        const $this = wo$(this);
                        const transaction = $this.data('transaction');
                        const supplier = $this.data('supplier');
                        if (transaction === 'GoToSite') {
                            const href = $this.attr('href');
                            $this.attr(
                                'href',
                                href +
                                    (href.indexOf('?') === -1 ? '?' : '&') +
                                    'r=' +
                                    ReferrerHelper.getReferrerEncoded()
                            );
                        }

                        $this.on('click', function () {
                            WhistleOut.trackEvent('BroadbandSpeed', transaction, supplier);
                        });
                    });
                widget
                    .find('#connection-type-select')
                    .off('change')
                    .on('change', function () {
                        var connectionType = this.value;
                        wo$('[data-connection-type-results]').hide();
                        wo$('[data-connection-type-results="' + connectionType + '"]').show();

                        getWidget()[0].dispatchEvent(new Event('resize'));
                    });
            }
        };

        WhistleOut.initWidget = controller.init;
        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
